module.exports = __webpack_public_path__ + "06a68c5aa3f62c6d3d87ec06bdb1e93b.png";